import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";

function HomeMember({ member }) {
  const [isOpen, setIsOpen] = useState(false);

  const bintiMembers = member;
  const soarMembers = member.filter((m) => m.source === "SOAR");

  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  return (
    <>
      <Modal show={isOpen} animation={false} onHide={() => setIsOpen(false)}>
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>{member[0].name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {bintiMembers && bintiMembers.length > 0 ? (
            <div className="border border-dark rounded mb-2 p-2 bg-safy3-50">
              <div className="fw-bold mb-2">{`Binti - ${bintiMembers[0].type} - ${bintiMembers[0].contactid}`}</div>
              <div className="row mb-2">
                <div className="col">First</div>
                <div className="col">Middle</div>
                <div className="col">Last</div>
              </div>
              <div className="row mb-2 fw-bold">
                <div className="col">{bintiMembers[0].firstname}</div>
                <div className="col">{bintiMembers[0].middlename}</div>
                <div className="col">{bintiMembers[0].lastname}</div>
              </div>
              <hr />
              <div className="row mb-2">
                <div className="col">Email</div>
                <div className="col fw-bold">
                  {bintiMembers[0].emailaddress1 !== null && (
                    <a
                      href={`mailto:${bintiMembers[0].emailaddress1}`}
                    >{`${bintiMembers[0].emailaddress1}`}</a>
                  )}
                </div>
              </div>
              {bintiMembers[0].emailaddress2 ? (
                <div className="row mb-2">
                  <div className="col">Email 2</div>
                  <div className="col fw-bold">
                    {bintiMembers[0].emailaddress2 !== null && (
                      <a
                        href={`mailto:${bintiMembers[0].emailaddress2}`}
                      >{`${bintiMembers[0].emailaddress2}`}</a>
                    )}
                  </div>
                </div>
              ) : null}
              <div className="row mb-2">
                <div className="col">Telephone</div>
                <div className="col fw-bold">{bintiMembers[0].telephone1}</div>
              </div>
              {bintiMembers[0].telephone2 ? (
                <div className="row mb-2">
                  <div className="col">Telephone2</div>
                  <div className="col fw-bold">
                    {bintiMembers[0].telephone2}
                  </div>
                </div>
              ) : null}
              <div className="row mb-2">
                <div className="col">Mobile</div>
                <div className="col fw-bold">{bintiMembers[0].mobilephone}</div>
              </div>
              <div className="row mb-4">
                <div className="col">Primary Contact</div>
                <div className="col fw-bold">
                  {bintiMembers[0].primarycontact}
                </div>
              </div>
              <hr />
              {bintiMembers[0].createdon ? (
                <div className="row mb-2">
                  <div className="col">{`Created: ${bintiMembers[0].createdon}`}</div>
                  <div className="col">
                    {`Updated: ${bintiMembers[0].updatedon}`}
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
          {soarMembers.map((m, index) => (
            <div
              className="border border-dark rounded mb-2 p-2 bg-safy1-3"
              key={`${m.contactid}-${index}`}
            >
              <div className="fw-bold mb-2">
                <Link
                  id={m.contactid}
                  title="Foster Parent Contact Record"
                  to={`/contact/${m.contactid}`}
                >
                  {`SOAR - ${m.type}`}
                </Link>
              </div>
              <div className="row mb-2">
                <div className="col">First</div>
                <div className="col">Middle</div>
                <div className="col">Last</div>
              </div>
              <div className="row mb-2 fw-bold">
                <div className="col">{m.firstname}</div>
                <div className="col">{m.middlename}</div>
                <div className="col">{m.lastname}</div>
              </div>
              <hr />
              <div className="row mb-2">
                <div className="col">Email</div>
                <div className="col fw-bold">
                  {m.emailaddress1 !== null && (
                    <a
                      href={`mailto:${m.emailaddress1}`}
                    >{`${m.emailaddress1}`}</a>
                  )}
                </div>
              </div>
              {m.emailaddress2 ? (
                <div className="row mb-2">
                  <div className="col">Email 2</div>
                  <div className="col fw-bold">
                    {m.emailaddress2 !== null && (
                      <a
                        href={`mailto:${m.emailaddress2}`}
                      >{`${m.emailaddress2}`}</a>
                    )}
                  </div>
                </div>
              ) : null}
              <div className="row mb-2">
                <div className="col">Telephone</div>
                <div className="col fw-bold">{m.telephone1}</div>
              </div>
              {m.telephone2 ? (
                <div className="row mb-2">
                  <div className="col">Telephone2</div>
                  <div className="col fw-bold">{m.telephone2}</div>
                </div>
              ) : null}
              <div className="row mb-2">
                <div className="col">Mobile</div>
                <div className="col fw-bold">{m.mobilephone}</div>
              </div>
              <div className="row mb-4">
                <div className="col">Primary Contact</div>
                <div className="col fw-bold">{m.primarycontact}</div>
              </div>
              <hr />
              {m.createdon ? (
                <div className="row mb-2">
                  <div className="col">{`Created: ${m.createdon}`}</div>
                  <div className="col">{`Updated: ${m.updatedon}`}</div>
                </div>
              ) : null}
              {m.effective ? (
                <div className="row mb-2">
                  <div className="col">{`Effective: ${m.effective}`}</div>
                  <div className="col">
                    {m.expiration !== null ? `Expiration: ${m.expiration}` : ""}
                  </div>
                </div>
              ) : null}
            </div>
          ))}
          <hr />
          {/* <div className="bg-success rounded p-2 text-white">Case Notes</div>
          <div>Case Note history to applicant coming soon</div>
          <hr />
          {safyInfo?.user?.modules?.includes("Admin") ? (
            <>
              <div className="bg-warning rounded p-2 fw-bold">Admin</div>
              <div className="row">
                <div className="col">Azure ID</div>
                <div className="col">XXX</div>
              </div>
              <div className="row">
                <div className="col">CRM User ID</div>
                <div className="col">xxx</div>
              </div>
              <div className="row">
                <div className="col">CRM Contact Name</div>
                <div className="col">xxx</div>
              </div>
              <div className="row">
                <div className="col">SAGE ID</div>
                <div className="col">...</div>
              </div>
            </>
          ) : null} */}
        </Modal.Body>
      </Modal>
      <div
        className="border border-dark bg-warning rounded mb-1 px-1"
        role="button"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <i
          className={"fas fa-user me-2 text-dark"}
          title={
            bintiMembers.length > 0 && soarMembers.length > 0
              ? `Soar and Binti (${member.length})`
              : bintiMembers.length > 0
              ? `Binti Only (${member.length})`
              : `SOAR Only (${member.length})`
          }
        ></i>
        {`${member[0].name}`}
      </div>
    </>
  );
}

export default HomeMember;
